import React, { useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import { FORM_FIELDS_MAP } from 'features/sendouts/components/drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.constants';
import strings from 'strings';
import CustomDatePicker from 'UI/components/atoms/CustomDatePicker';
import { REQUIRED_VALIDATION } from 'UI/utils';

import { DEFAULT_TIME_PICKER_PROPS } from '../constants';
import { TimezoneSelector } from '../TimezoneSelector';

const STRINGS = strings.sendouts.form;

export const FixedHourFields = () => {
  const { control, errors } = useFormContext();
  const handleControllerChange = useCallback(([, value]) => value, []);

  return (
    <>
      <Grid item xs={6}>
        <Controller
          name={FORM_FIELDS_MAP.InterviewTime.key}
          control={control}
          rules={REQUIRED_VALIDATION}
          defaultValue={null}
          as={
            <CustomDatePicker
              disablePast
              isClearable
              error={!!errors[FORM_FIELDS_MAP.InterviewTime.key]}
              helperText={errors[FORM_FIELDS_MAP.InterviewTime.key]?.message}
              label={STRINGS.labels.hour}
              name={FORM_FIELDS_MAP.InterviewTime.key}
              variant="keyboardTime"
              withTime
              {...DEFAULT_TIME_PICKER_PROPS}
            />
          }
          onChange={handleControllerChange}
          onChangeName="onDateChange"
          valueName="value"
        />
      </Grid>
      <Grid item xs={6}>
        <TimezoneSelector />
      </Grid>
    </>
  );
};
